import React from 'react';
import { UsersIcon, MessagesSquareIcon, TrendingUpIcon, GlobeIcon } from 'lucide-react';
const Stats = () => {
  return <section id="stats" className="py-16 bg-white" data-id="element-340">
      <div className="container mx-auto px-4" data-id="element-341">
        <div className="text-center mb-16" data-id="element-342">
          <h2 className="text-3xl font-bold mb-4" data-id="element-343">Usage</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-344">
            Since our early 2025 U.S.-based proof-of-concept launch, Voxie has
            shown impressive growth and engagement metrics through word-of-mouth
            alone.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-345">
          <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-346">
            <div className="inline-block p-3 bg-[#e5f8f7] rounded-full mb-4" data-id="element-347">
              <UsersIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-348" />
            </div>
            <div className="text-4xl font-bold text-[#54d4cb] mb-2" data-id="element-349">
              10,000+
            </div>
            <p className="text-gray-600 font-medium" data-id="element-350">Active Users</p>
            <p className="text-sm text-gray-500 mt-2" data-id="element-351">Via word-of-mouth only</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-352">
            <div className="inline-block p-3 bg-[#e5f8f7] rounded-full mb-4" data-id="element-353">
              <MessagesSquareIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-354" />
            </div>
            <div className="text-4xl font-bold text-[#54d4cb] mb-2" data-id="element-355">1M+</div>
            <p className="text-gray-600 font-medium" data-id="element-356">Monthly Interactions</p>
            <p className="text-sm text-gray-500 mt-2" data-id="element-357">
              Doubling month-over-month
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-358">
            <div className="inline-block p-3 bg-[#e5f8f7] rounded-full mb-4" data-id="element-359">
              <TrendingUpIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-360" />
            </div>
            <div className="text-4xl font-bold text-[#54d4cb] mb-2" data-id="element-361">20+</div>
            <p className="text-gray-600 font-medium" data-id="element-362">Daily Interactions</p>
            <p className="text-sm text-gray-500 mt-2" data-id="element-363">Per active user</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-364">
            <div className="inline-block p-3 bg-[#e5f8f7] rounded-full mb-4" data-id="element-365">
              <GlobeIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-366" />
            </div>
            <div className="text-4xl font-bold text-[#54d4cb] mb-2" data-id="element-367">Higher</div>
            <p className="text-gray-600 font-medium" data-id="element-368">Usage Rate</p>
            <p className="text-sm text-gray-500 mt-2" data-id="element-369">
              Than ChatGPT and Google
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Stats;